import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListHLSTranscoder from '../../components/content/list-hls-transcoder.component';

const HLSTranscoderView = () => {
  const pageTitle = 'Encode Videos / HLS Encoder (Legacy Storage)';

  return (
    <AppLayout pageTitle={pageTitle}>
      <ListHLSTranscoder />
    </AppLayout>
  );
};

export default HLSTranscoderView;
